import { cn } from '~/lib/utils'
import type { ExploreLevel, ExploreOption } from './types'

const LEVEL_TITLES: Record<ExploreLevel, string> = {
    combo: '① 규모·평가·단계',
    industry: '② 업종',
    major: '③ 대분류',
    middle: '④ 중분류',
}

export interface ExploreOptionColumnProps {
    level: ExploreLevel
    value: string
    options: ExploreOption[]
    emptyMessage?: string
    onSelect(level: ExploreLevel, value: string): void
}

/** 찾아보기 단계별 선택지를 좌→우 드릴다운 컬럼으로 표시한다. */
export function ExploreOptionColumn({
    level,
    value,
    options,
    emptyMessage = '해당 조건의 항목이 없습니다.',
    onSelect,
}: ExploreOptionColumnProps) {
    return (
        <section className='bg-card border-border flex min-h-0 w-[13rem] shrink-0 flex-col rounded-sm border'>
            <div className='border-border shrink-0 border-b px-3 py-2'>
                <h2 className='text-muted-foreground text-xs font-extrabold tracking-wide'>
                    {LEVEL_TITLES[level]}
                </h2>
            </div>
            <div className='min-h-0 flex-1 overflow-y-auto p-2'>
                {options.length > 0 ? (
                    <div className='grid gap-1'>
                        {options.map((option) => {
                            const selected = option.value === value
                            return (
                                <button
                                    key={option.value}
                                    type='button'
                                    onClick={() =>
                                        onSelect(level, option.value)
                                    }
                                    className={cn(
                                        'hover:bg-muted grid grid-cols-[minmax(0,1fr)_auto] items-center gap-2 rounded-sm border border-transparent px-3 py-2 text-left text-sm leading-5 transition-colors',
                                        selected
                                            ? 'border-primary/30 bg-accent text-primary font-bold'
                                            : 'text-foreground'
                                    )}>
                                    <span className='min-w-0 truncate'>
                                        {option.label}
                                    </span>
                                    <span
                                        className={cn(
                                            'text-xs tabular-nums',
                                            selected
                                                ? 'text-primary'
                                                : 'text-muted-foreground'
                                        )}>
                                        {option.count}
                                    </span>
                                </button>
                            )
                        })}
                    </div>
                ) : (
                    <div className='grid min-h-32 place-items-center px-2 text-center'>
                        <p className='text-muted-foreground text-xs leading-5'>
                            {emptyMessage}
                        </p>
                    </div>
                )}
            </div>
        </section>
    )
}
